import React from 'react';
import { Tree, Airplane, Leaf } from '@phosphor-icons/react';
import { formatNumber } from '../lib/pendelLogic';

export default function CO2Panel({ results }) {
  const { annual_co2_kg, trees_needed, flights_equivalent } = results;
  if (!annual_co2_kg || annual_co2_kg < 1) return null;

  return (
    <div className="mt-12" data-testid="co2-panel">
      <div className="flex items-end justify-between">
        <h2 className="font-display text-3xl md:text-4xl tracking-tighter">CO₂-Bilanz deines Arbeitswegs</h2>
        <div className="hidden md:block h-px flex-1 bg-neutral-200 mx-6 mb-2" />
      </div>

      <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-0 grid-border">
        <div className="p-6 md:p-8 border-neutral-200 [&:not(:last-child)]:border-b md:[&:not(:last-child)]:border-b-0 md:[&:not(:last-child)]:border-r bg-neutral-900 text-white" data-testid="co2-total">
          <div className="text-xs uppercase tracking-widest text-white/70 inline-flex items-center gap-2">
            <Leaf size={14} weight="bold" /> CO₂ pro Jahr
          </div>
          <div className="font-display text-5xl md:text-6xl mt-3 tnum">
            {formatNumber(annual_co2_kg)} kg
          </div>
          <div className="text-sm text-white/80 mt-2">
            Direktemissionen aus Sprit für deinen Arbeitsweg.
          </div>
        </div>
        <div className="p-6 md:p-8 border-neutral-200 [&:not(:last-child)]:border-b md:[&:not(:last-child)]:border-b-0 md:[&:not(:last-child)]:border-r bg-white" data-testid="co2-trees">
          <div className="text-xs uppercase tracking-widest text-neutral-500 inline-flex items-center gap-2">
            <Tree size={14} weight="bold" /> Bäume nötig
          </div>
          <div className="font-display text-5xl md:text-6xl mt-3 tnum">{Math.ceil(trees_needed)}</div>
          <div className="text-sm text-neutral-700 mt-2">
            ausgewachsene Bäume, die dein CO₂ ein Jahr lang kompensieren würden.
          </div>
        </div>
        <div className="p-6 md:p-8 bg-white" data-testid="co2-flights">
          <div className="text-xs uppercase tracking-widest text-neutral-500 inline-flex items-center gap-2">
            <Airplane size={14} weight="bold" /> Flug-Äquivalent
          </div>
          <div className="font-display text-5xl md:text-6xl mt-3 tnum">{flights_equivalent.toFixed(1)}×</div>
          <div className="text-sm text-neutral-700 mt-2">
            Hin- und Rückflüge München&nbsp;–&nbsp;Mallorca (pro Person).
          </div>
        </div>
      </div>
      <p className="text-xs text-neutral-500 mt-3">
        Berechnung: 2,32 kg CO₂/L bei Benzin (E5/E10), 2,65 kg/L bei Diesel. Quellen: Umweltbundesamt 2024, BUND (Baumkompensation).
      </p>
    </div>
  );
}
